import React from "react";
import { Link } from "react-router-dom";
export default function UsersListRow(props) {
  let values = [];
  for (let field in props) values.push(field);

  let literal = props["name"] ? props["name"][0].toUpperCase() : null;
  let literalBg = "bg-light";
  if (props.lock_date) literalBg = "bg-light-danger";

  return (
    <Link to={`/admin/users/${props.id}/`}>
      <div className="row py-4  border-bottom text-dark bg-hover-light">
        <div className="col-lg-3 m-lg-0 my-3">
          <div className="d-flex justify-content-start align-items-center">
            <div className="symbol symbol-20 symbol-lg-40 mr-3 align-middle">
              {props.picture ? (
                <img alt="userpic" src={props.picture} />
              ) : (
                <span className={`symbol-label ${literalBg}`}>{literal}</span>
              )}
              {props.status === 2 ? (
                <i className="symbol-badge bg-success symbol-badge-bottom"></i>
              ) : null}
            </div>
            {props.name}
          </div>
        </div>

        <div
          style={{ wordBreak: "break-all" }}
          className={`col-lg-3 m-lg-0 my-3 d-flex align-items-center ${
            props.username.length > 25 ? "font-size-sm" : ""
          }`}
        >
          {props.username}
        </div>
        <div className="col-lg-2  d-flex align-items-center">
          {props.phone || ""}
        </div>
        <div className="col-lg-2  d-flex align-items-center">
          {props.email || ""}
        </div>
        <div className="col-lg-2  d-flex align-items-center  font-size-sm text-muted">
          {props.description}
        </div>
      </div>
    </Link>
  );
}
